import { AppForm } from '../../../../../../common/forms/app.form';
import { Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite,
  PropertyLegalTitleAppEntityDictionaryPropertyLegalTitle, PropertyLegalTitleService
} from '../../../../../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';


export type PostInvestmentUsageItem
  = 'Nie ulegnie zmianie'
  | 'Ulegnie zmianie na przemysłowy'
  | 'Ulegnie zmianie na usługowy'
  | 'Ulegnie zmianie na mieszkaniowy'
  | 'Ulegnie zmianie na inny cel'
  | '';

export type PurposeOfUseItem = 'Przemysłowy' | 'Usługowy' | 'Mieszkaniowy' | 'Rolniczy' | 'Inny' | string;

export class PropertyInfoForm extends AppForm {
  public purposeOfUseList: PurposeOfUseItem[] = [
    'Przemysłowy',
    'Usługowy',
    'Mieszkaniowy',
    'Rolniczy',
    'Inny'
  ];

  public postInvestmentUsages: PostInvestmentUsageItem[] = [
    'Nie ulegnie zmianie',
    'Ulegnie zmianie na przemysłowy',
    'Ulegnie zmianie na usługowy',
    'Ulegnie zmianie na mieszkaniowy',
    'Ulegnie zmianie na inny cel'
  ];

  public propertyLegalTitles: PropertyLegalTitleAppEntityDictionaryPropertyLegalTitle[] = [];

  constructor(private pr: PropertyLegalTitleService) {
    super({
      purposeOfUse: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      propertyLegalTitle: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      postInvestmentUsage: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      referenceVehicleType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      propertyParkingSpacesCount: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
    this.pr?.getPropertyLegalTitleCollectionPropertyLegalTitleCollection({ pagination: false })
      .subscribe(v => this.propertyLegalTitles = v);
  }

  public get postInvestmentUsage(): FormControl | null {
    return this.get('postInvestmentUsage') as FormControl | null;
  }

  public get propertyParkingSpacesCount(): FormControl | null {
    return this.get('propertyParkingSpacesCount') as FormControl | null;
  }

  public get propertyLegalTitleDesc(): FormControl | null {
    return this.get('propertyLegalTitleDesc') as FormControl | null;
  }

  public get purposeOfUseDesc(): FormControl | null {
    return this.get('purposeOfUseDesc') as FormControl | null;
  }

  public propertyLegalTitleChange(v: string): void {
    if (v === '614eba03-8e27-46d0-8b0c-96fbf137460c') {
      this.addControl('propertyLegalTitleDesc', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('propertyLegalTitleDesc');
    }
  }

  public purposeOfUseChange(v: PurposeOfUseItem | string): void {
    if (v === 'Inny') {
      this.addControl('purposeOfUseDesc', new FormControl('', [Validators.required, Validators.maxLength(5000)]));
    } else {
      this.removeControl('purposeOfUseDesc');
    }
  }

  public postInvestmentUsageChange(v: PostInvestmentUsageItem | string): void {
    if (v === 'Ulegnie zmianie na inny cel') {
      this.addControl('propertyUsageChange', new FormControl('', [Validators.required, Validators.maxLength(5000)]));
    } else {
      this.removeControl('propertyUsageChange');
    }
  }

  public override patchFormValues(app: ApplicationAppEntityApplicationRead) {
    this.purposeOfUseChange(app.propertyUsagePurpose as PurposeOfUseItem);
    this.postInvestmentUsageChange(app.postInvestmentUsage as PostInvestmentUsageItem);
    this.propertyLegalTitleChange(app?.propertyLegalTitle?.id || '');
    super.patchFormValues({
      ...app,
      propertyLegalTitle: app?.propertyLegalTitle?.id || '',
      purposeOfUse: app?.propertyUsagePurpose
    });
    if (app?.propertyUsagePurposeText) {
      this.patchValue({ purposeOfUseDesc: app.propertyUsagePurposeText });
    }
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      propertyUsagePurpose: this.value.purposeOfUse,
      propertyUsagePurposeText: this.value?.purposeOfUseDesc || undefined,
      propertyLegalTitle: this.value?.propertyLegalTitle,
      propertyLegalTitleDesc: this.value?.propertyLegalTitleDesc,
      postInvestmentUsage: this.value?.postInvestmentUsage,
      propertyUsageChange: this.value?.propertyUsageChange,
      referenceVehicleType: this.value?.referenceVehicleType,
      propertyParkingSpacesCount: this.value?.propertyParkingSpacesCount ? +this.value?.propertyParkingSpacesCount : undefined
    };
  }
}
